import React from 'react'
import SetTitle from '../../utils/set_title'
import PEDForm from './PEDForm'
import Header from '../../components/Headers/Header'

export default function PED() {
  SetTitle('PED Generator')
  const description =
    "Partendo da un file excel di keyword fornite in input crea un topic scouting e genera un piano editoriale comprensivo di Abstract/Brief che poi può essere passato ai copy per la stesura dei contenuti (oppure a GPT in caso di scrittura articoli tramite AI)."

  return (
    <Header
      iconClass="ni ni-align-left-2 text-white"
      title="PED Generator"
      description={description}
    >
      <PEDForm />
    </Header>
  )
}